import React from "react";
import { ReactController } from "../react_controller";
import PrimerRoot from "../../components/PrimerRoot";
import { ResourceAccessPopover } from "../../components/admin/access";

// Stimulus React entry for the resource access widget. PrimerRoot provides
// ThemeProvider + BaseStyles (so the popover picks up the codebase's theme
// tokens) plus the StyleSheetManager guard that keeps styled-components'
// runtime styles in <style> text content — without it, Turbo's <head> merge
// can dedup the empty injected tags and the widget paints unstyled.
// See app/javascript/components/PrimerRoot.tsx and the parallel fix on the
// Chakra side at ChakraProviderWithNonce.tsx:26-30 for the full mechanism.
export class ResourceAccessController extends ReactController {
  connect() {
    this.root.render(
      <PrimerRoot>
        <ResourceAccessPopover {...this.propsValue} />
      </PrimerRoot>
    );
  }
}
